
/**
 * This component is responsible for adding the hyper-local pollution images,
 * ie. the high-resolution colors when the user zooms on a location where we
 * have a model running.
 */
import {Map} from 'mapbox-gl';
import moment from 'moment';
import { defineComponent } from 'vue';

import PollutionLayerHyperlocal from './pollution-layer-hyperlocal.vue';

export default defineComponent({

  props: {
    map: {
      type: Map,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
  },

  components: {
    PollutionLayerHyperlocal,
  },

  computed: {
    /**
     * Overlay to add to the map
     */
    overlay() {
      const baseUrl = `https://storage.googleapis.com/elichens-aqmap/${this.location.location_name}/tiles/`;

      const DATE_FORMAT = 'YYYYMMDDHH';
      const formattedDate = moment().utc().format(DATE_FORMAT);

      const url = `${baseUrl}${formattedDate}`;

      return {
        url,
        bounds: this.location.bbox,
      };
    },
    pollutant() {
      return 'AQI';
      // let pollutant =
      //   this.selectedPollutant.code === 'global'
      //     ? 'AQI'
      //     : this.selectedPollutant.code;

      // if (pollutant === 'PM10') pollutant = 'P10';
      // else if (pollutant === 'PM2_5') pollutant = 'P25';

      // const suffix =
      //   this.currentdisplay === 'aqi' &&
      //   this.selectedPollutant.code !== 'global'
      //     ? 'i'
      //     : '';

      // return pollutant + suffix;
    },
  },
});
